import {
    Button, Count, Dialog, Label
} from '@wg/wows-react-uikit';
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import styles from './DevPanel.scss';
import type { RootState } from '~/store';
import {
    addEventin,
    deleteAccount,
    setDefaultDates,
    setEventEndDate,
    setEventStartDate,
    switchSync,
    turnGuideOff,
    turnGuideOn,
} from '~/store/app';
import {
    closeFinalDialog,
    closeMultipleBuyDialog,
    closeShipFeaturesDialog,
    hideBlueprintsViewer,
    openFinalDialog,
    openMultipleBuyDialog,
    openShipFeaturesDialog,
    showBlueprintsViewer,
    showFinalVideo,
    showIntroVideo,
    showLaunchVideo,
} from '~/store/dialogs';
import {
    setShipLevelLocal as setShipLevel,
} from '~/store/client';
import { timing } from '~/utils/updateProgressSpeed';
import { searchToObject } from '~/utils';

const queryParams = searchToObject();
const isSuperTest = queryParams.superTest === true;
const isDevMode = queryParams.devMode === true;

interface OwnProps {
    [propName: string]: unknown,
}

interface DispatchProps {
    setShipLevel: (level: number) => void,
    turnGuideOn: () => void,
    turnGuideOff: () => void,
    deleteAccount: () => void,
    switchSync: () => void,
    showIntroVideo: () => void,
    showLaunchVideo: () => void,
    showFinalVideo: () => void,
    addEventin: (value: number) => void,
    setEventStartDate: (date: number) => void,
    setEventEndDate: (date: number) => void,
    setDefaultDates: () => void,
    showBlueprintsViewer: () => void,
    hideBlueprintsViewer: () => void,
    closeMultipleBuyDialog: () => void,
    openMultipleBuyDialog: () => void,
    closeShipFeaturesDialog: () => void,
    openShipFeaturesDialog: (shipId: number | string) => void,
    openFinalDialog: () => void,
    closeFinalDialog: () => void,
}

interface StateProps {
    shipLevel: number,
    guideIsRunning: boolean,
    isSyncEnabled: boolean,
    isBlueprintsViewerVisible: boolean,
    isMultipleBuyDialogVisible: boolean,
    isShipFeaturesDialogVisible: boolean,
    isFinalDialogOpen: boolean,
    showDevPanel: boolean,
    showResetButton: boolean,
    mainRewardShipId: string,
}

export type IProps = StateProps & OwnProps & DispatchProps;

interface IState {
    isOpened: boolean,
    isDevFrameVisible: boolean,
    isPendingFrameVisible: boolean,
    isTimingDialogVisible: boolean,
    videoId: null | number,
    addEventin: number,
    startDateDays: number,
    endDateDays: number,
}

const getMs = (days: number): number => {
    return days * 24 * 60 * 60 * 1000;
};

class DevPanel extends Component<IProps, IState> {
    state: IState = {
        isOpened: false,
        isDevFrameVisible: false,
        isPendingFrameVisible: false,
        isTimingDialogVisible: false,
        videoId: null,
        addEventin: 0,
        startDateDays: 0,
        endDateDays: 0,
    };

    toggleOpen = () => {
        this.setState({ isOpened: !this.state.isOpened });
    };

    upLevel = (levelKey: string) => () => {
        switch (levelKey) {
            case 'ship_level': {
                const level = this.props.shipLevel + 1;
                this.props.setShipLevel(level);
                break;
            }
        }
    };

    downLevel = (levelKey: string) => () => {
        switch (levelKey) {
            case 'ship_level': {
                let level = this.props.shipLevel - 1;
                if (level < 0) {
                    level = 0;
                }
                this.props.setShipLevel(level);
                break;
            }
        }
    };

    hideDevFrame = () => {
        this.setState({ isDevFrameVisible: false });
    };

    showDevFrame = () => {
        this.setState({ isDevFrameVisible: true });
    };

    hidePendingFrame = () => {
        this.setState({ isPendingFrameVisible: false });
    };

    showPendingFrame = () => {
        this.setState({ isPendingFrameVisible: true });
    };

    hideTimingDialog = () => {
        this.setState({ isTimingDialogVisible: false });
    };

    showTimingDialog = () => {
        this.setState({ isTimingDialogVisible: true });
    };

    renderPublicTestPanel = () => {
        return (
            <div className={`${styles.wrapper} ${this.state.isOpened ? styles.wrapperOpened : ''}`}>
                <div className={styles.content}>
                    <div onClick={this.toggleOpen} className={`${styles.openButton} ${this.state.isOpened ? styles.openButtonClose : ''}`} />
                    {this.props.showResetButton && (
                        <div className={styles.param}>
                            <Label>{'Аккаунт'}</Label>
                            <div className={styles.rowWide}>
                                <Button isFlat={true} onClick={this.props.deleteAccount}>
                                    {'Удалить'}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    switchBlueprintsViewerVisible = () => {
        if (this.props.isBlueprintsViewerVisible) {
            this.props.hideBlueprintsViewer();
        } else {
            this.props.showBlueprintsViewer();
        }
    };

    switchMultipleBuyVisible = () => {
        if (this.props.isMultipleBuyDialogVisible) {
            this.props.closeMultipleBuyDialog();
        } else {
            this.props.openMultipleBuyDialog();
        }
    };

    switchFinalVisible = () => {
        if (this.props.isFinalDialogOpen) {
            this.props.closeFinalDialog();
        } else {
            this.props.openFinalDialog();
        }
    };

    switchShipFeaturesVisible = () => {
        if (this.props.isShipFeaturesDialogVisible) {
            this.props.closeShipFeaturesDialog();
        } else {
            this.props.openShipFeaturesDialog(this.props.mainRewardShipId);
        }
    };

    renderTimingContent = () => {
        return (
            <div>
                <h3>{'Просмотри необходимые уровни, затем открой это окно'}</h3>
                <textarea className={styles.timings} defaultValue={timing.showTimings()} />
            </div>
        );
    };

    render() {
        if ((isDevMode && !this.props.showDevPanel) || (isSuperTest && !this.props.showResetButton)) {
            return null;
        }

        if (isSuperTest) {
            return this.renderPublicTestPanel();
        }

        return (
            <div className={`${styles.wrapper} ${this.state.isOpened ? styles.wrapperOpened : ''}`}>
                <div className={styles.content}>
                    <div onClick={this.toggleOpen} className={`${styles.openButton} ${this.state.isOpened ? styles.openButtonClose : ''}`} />

                    <div className={styles.param}>
                        <Label>{'Phase'}</Label>
                        <div className={styles.row}>
                            <Button isFlat={true} onClick={this.downLevel('ship_level')}>
                                {'-'}
                            </Button>
                            <div className={styles.spacer}>
                                <span className={styles.value}>{this.props.shipLevel}</span>
                            </div>
                            <Button isFlat={true} onClick={this.upLevel('ship_level')}>
                                {'+'}
                            </Button>
                        </div>
                    </div>

                    {this.props.showResetButton && (
                        <div className={styles.param}>
                            <Label>{'User account'}</Label>
                            <div className={styles.rowWide}>
                                <Button isFlat={true} onClick={this.props.deleteAccount}>
                                    {'Delete'}
                                </Button>
                            </div>
                        </div>
                    )}

                    <div className={styles.param}>
                        <Label>{'Pending'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.showPendingFrame}>
                                {'Open'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Timing'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.showTimingDialog}>
                                {'Open'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Education'}</Label>
                        <div className={styles.rowWide}>
                            {this.props.guideIsRunning ? (
                                <Button isFlat={true} onClick={this.props.turnGuideOff}>
                                    {'Off'}
                                </Button>
                            ) : (
                                <Button isFlat={true} onClick={this.props.turnGuideOn}>
                                    {'On'}
                                </Button>
                            )}
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Sync'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.props.switchSync}>
                                {this.props.isSyncEnabled ? 'Off' : 'On'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Blueprints'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.switchBlueprintsViewerVisible}>
                                {this.props.isBlueprintsViewerVisible ? 'Hide' : 'Show'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Buy dlg'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.switchMultipleBuyVisible}>
                                {this.props.isMultipleBuyDialogVisible ? 'Hide' : 'Show'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Final dlg'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.switchFinalVisible}>
                                {this.props.isFinalDialogOpen ? 'Hide' : 'Show'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'ShipFeat dlg'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.switchShipFeaturesVisible}>
                                {this.props.isShipFeaturesDialogVisible ? 'Hide' : 'Show'}
                            </Button>
                        </div>
                    </div>

                    <div className={styles.param}>
                        <Label>{'Видео'}</Label>
                        <div className={styles.row}>
                            <Button isFlat={true} onClick={this.props.showIntroVideo}>
                                {'1'}
                            </Button>
                            <Button isFlat={true} onClick={this.props.showLaunchVideo}>
                                {'2'}
                            </Button>
                            <Button isFlat={true} onClick={this.props.showFinalVideo}>
                                {'3'}
                            </Button>
                        </div>
                    </div>
                    <div className={styles.param}>
                        <Label>{'Dockyardum'}</Label>
                        <div className={styles.row}>
                            <Count
                                value={this.state.addEventin}
                                // eslint-disable-next-line react/jsx-no-bind
                                onChange={(value: number) => {
                                    this.setState({ addEventin: value });
                                }}
                            />
                            <div className={styles.fullButton}>
                                <Button
                                    isFlat={true}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={() => {
                                        this.props.addEventin(this.state.addEventin);
                                        this.setState({ addEventin: 0 });
                                    }}
                                >
                                    {'topup'}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={styles.param}>
                        <Label>{'Start (d)'}</Label>
                        <div className={styles.row}>
                            <Count
                                min={-30}
                                value={this.state.startDateDays}
                                // eslint-disable-next-line react/jsx-no-bind
                                onChange={(value: number) => {
                                    this.setState({ startDateDays: value });
                                }}
                            />
                            <div className={styles.fullButton}>
                                <Button
                                    isFlat={true}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={() => {
                                        const now = moment.utc().unix() * 1000;
                                        const startDate = now + getMs(this.state.startDateDays);
                                        this.props.setEventStartDate(startDate);
                                        this.setState({ startDateDays: 0 });
                                    }}
                                >
                                    {'set'}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={styles.param}>
                        <Label>{'Finish (d)'}</Label>
                        <div className={styles.row}>
                            <Count
                                min={-30}
                                value={this.state.endDateDays}
                                // eslint-disable-next-line react/jsx-no-bind
                                onChange={(value: number) => {
                                    this.setState({ endDateDays: value });
                                }}
                            />
                            <div className={styles.fullButton}>
                                <Button
                                    isFlat={true}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={() => {
                                        const now = moment.utc().unix() * 1000;
                                        const endDate = now + getMs(this.state.endDateDays);
                                        this.props.setEventEndDate(endDate);
                                        this.setState({ endDateDays: 0 });
                                    }}
                                >
                                    {'Set'}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={styles.param}>
                        <Label>{'Dates'}</Label>
                        <div className={styles.rowWide}>
                            <Button isFlat={true} onClick={this.props.setDefaultDates}>
                                {'Reset'}
                            </Button>
                        </div>
                    </div>
                </div>
                <Dialog
                    content={this.renderTimingContent()}
                    size={'extra-large'}
                    isOverlay={false}
                    isVisible={this.state.isTimingDialogVisible}
                    hideDialog={this.hideTimingDialog}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): StateProps => ({
    shipLevel: state.app.shipLevel,
    guideIsRunning: state.app.guideIsRunning,
    isSyncEnabled: state.app.isSyncEnabled,
    isBlueprintsViewerVisible: state.dialogs.isBlueprintsViewerVisible,
    isMultipleBuyDialogVisible: state.dialogs.isMultipleBuyDialogVisible,
    isShipFeaturesDialogVisible: state.dialogs.isShipFeaturesDialogVisible,
    isFinalDialogOpen: state.dialogs.isFinalDialogOpen,
    showDevPanel: state.app.showDevPanel,
    showResetButton: state.app.showResetButton,
    mainRewardShipId: state.app.mainRewardShipId,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, unknown, AnyAction>): DispatchProps => {
    return {
        setShipLevel: (level: number) => {
            dispatch(setShipLevel(level));
        },
        turnGuideOn: () => {
            dispatch(turnGuideOn());
        },
        turnGuideOff: () => {
            dispatch(turnGuideOff());
        },
        deleteAccount: () => {
            dispatch(deleteAccount());
        },
        switchSync: () => {
            dispatch(switchSync());
        },
        showIntroVideo: () => {
            dispatch(showIntroVideo());
        },
        showLaunchVideo: () => {
            dispatch(showLaunchVideo());
        },
        showFinalVideo: () => {
            dispatch(showFinalVideo());
        },
        addEventin: (value: number) => {
            dispatch(addEventin(value));
        },
        setEventStartDate: (date: number) => {
            dispatch(setEventStartDate(date));
        },
        setEventEndDate: (date: number) => {
            dispatch(setEventEndDate(date));
        },
        setDefaultDates: () => {
            dispatch(setDefaultDates());
        },
        showBlueprintsViewer: () => {
            dispatch(showBlueprintsViewer());
        },
        hideBlueprintsViewer: () => {
            dispatch(hideBlueprintsViewer());
        },
        openMultipleBuyDialog: () => {
            dispatch(openMultipleBuyDialog());
        },
        closeMultipleBuyDialog: () => {
            dispatch(closeMultipleBuyDialog());
        },
        openFinalDialog: () => {
            dispatch(openFinalDialog(''));
        },
        closeFinalDialog: () => {
            dispatch(closeFinalDialog());
        },
        openShipFeaturesDialog: (shipId: number | string) => {
            dispatch(openShipFeaturesDialog(shipId));
        },
        closeShipFeaturesDialog: () => {
            dispatch(closeShipFeaturesDialog());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DevPanel);
